import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "John Doe",
        title: "Flooring Expert",
        biography: "John Doe is a seasoned flooring expert with a deep understanding of various flooring materials and techniques. With years of experience in the industry, he specializes in delivering precise installations and refinishing services that enhance the beauty and functionality of interior spaces. His passion lies in transforming surfaces through craftsmanship and attention to detail.",
        contacts: {
            phone: "222-333-4455",
            email: "john.doe@gmail.com",
            website: "www.johndoe.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Senior Flooring Technician - Surface Masters",
            "Hardwood Refinishing Specialist",
            "Residential & Commercial Projects Lead",
            "Quality Control Coordinator",
            "Client Consultation & Support"
        ],
        skills: [
            { id: 1, title: "Hardwood Installation", progress: 92 },
            { id: 2, title: "Tile Flooring", progress: 88 },
            { id: 3, title: "Floor Repair", progress: 90 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Jane Smith",
        title: "Tiling Specialist",
        biography: "Jane Smith is a highly skilled tiling specialist known for her precision and artistic eye. With extensive experience in bathroom, kitchen, and commercial tiling projects, she excels in delivering high-quality tile installations that are both functional and visually appealing. Her commitment to craftsmanship ensures each tile is perfectly placed and built to last.",
        contacts: {
            phone: "333-444-5566",
            email: "jane.smith@gmail.com",
            website: "www.janesmithtiling.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Lead Tile Installer - Urban Tiling Co.",
            "Ceramic & Porcelain Tile Expert",
            "Custom Mosaic Designer",
            "Commercial Space Finisher",
            "Client Layout Consultant"
        ],
        skills: [
            { id: 1, title: "Tile Installation", progress: 94 },
            { id: 2, title: "Custom Patterns", progress: 89 },
            { id: 3, title: "Grout Application", progress: 91 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Michael Brown",
        title: "Paving Specialist",
        biography: "Michael Brown is an experienced paving specialist with a passion for transforming outdoor spaces. With a deep understanding of paving materials and techniques, he ensures every project is built for durability and visual appeal. Whether it's a driveway, walkway, or patio, Michael delivers precision and long-lasting results every time.",
        contacts: {
            phone: "444-555-6677",
            email: "michael.brown@gmail.com",
            website: "www.michaelpavingpro.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Senior Paving Technician - Elite Outdoor Works",
            "Driveway and Walkway Specialist",
            "Concrete & Asphalt Expert",
            "Outdoor Surface Designer",
            "Paving Quality Inspector"
        ],
        skills: [
            { id: 1, title: "Paving Installation", progress: 93 },
            { id: 2, title: "Surface Leveling", progress: 88 },
            { id: 3, title: "Material Selection", progress: 90 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Lisa Johnson",
        title: "Flooring Installer",
        biography: "Lisa Johnson is a skilled flooring installer with extensive experience in both hardwood and tile flooring projects. Known for her precision and attention to detail, Lisa ensures each installation is flawless and built to last. Her dedication to quality craftsmanship guarantees client satisfaction on every job.",
        contacts: {
            phone: "555-666-7788",
            email: "lisa.johnson@gmail.com",
            website: "www.lisaflooringpros.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Flooring Technician - Premier Floors Inc.",
            "Hardwood Specialist",
            "Tile Installation Expert",
            "Quality Control Coordinator",
            "Customer Service Liaison"
        ],
        skills: [
            { id: 1, title: "Hardwood Flooring", progress: 92 },
            { id: 2, title: "Tile Installation", progress: 90 },
            { id: 3, title: "Surface Preparation", progress: 88 }
        ]
    }

];

export default team;